<template>
  <div>
    <label class="replacement-label">WHEN IS YOUR BIRTHDAY?</label>
    <div class="form-row hide-label">
      <div class="col-12 col-md-4">
        <input-select
          id="month"
          v-model="value.month"
          name="month"
          label="Month"
          placeholder="Month"
          :options="monthOptions"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select
          id="day"
          v-model="value.day"
          name="day"
          label="Day"
          placeholder="Day"
          :options="dayOptions"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select
          id="year"
          v-model="value.year"
          name="year"
          label="Year"
          placeholder="Year"
          :options="yearOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'BirthdayPicker',

  components: {
    InputSelect
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    const year = new Date().getFullYear();

    return {
      monthOptions: Array(12)
        .fill()
        .map((_, i) => ({
          id: (i + 1).toString(),
          display_label: (i + 1).toString().padStart(2, '0')
        })),
      dayOptions: Array(31)
        .fill()
        .map((_, i) => ({
          id: (i + 1).toString(),
          display_label: (i + 1).toString().padStart(2, '0')
        })),
      yearOptions: Array(100)
        .fill()
        .map((_, i) => ({
          id: (year + i - 100).toString(),
          display_label: (year + i - 100).toString().padStart(2, '0')
        }))
    };
  },

  watch: {
    value: {
      deep: true,
      handler(v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hide-label {
  ::v-deep label {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}
</style>
